import {
	Box,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	Typography,
	Snackbar,
	Alert,
	CircularProgress,
	LinearProgress,
	Card,
	CardContent,
	Stack,
} from "@mui/material";
import { KeyboardArrowRight as KeyboardArrowRightIcon } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import useAuth from "../../../../hooks/useAuth";
import axios from "../../../../api/axios";
import MinerProgress from "./MinerProgress";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";

export default function MinerBotInfo(props) {
	const { minerName, price, hash, minerId } = props;
	const axiosPrivate = useAxiosPrivate();
	const { auth } = useAuth();

	// console.log(auth);

	// Modal state
	const [open, setOpen] = useState(false);
	const [dialogFeedback, setDialogFeedback] = useState({
		message: "",
		severity: "",
	});
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [insufficient, setInsufficient] = useState(false);

	// Snackbar
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState("");
	const [snackbarSeverity, setSnackbarSeverity] = useState("success");

	// Mining status
	const [isMining, setIsMining] = useState(false);
	const [miningProgress, setMiningProgress] = useState(0);
	const [loadingMining, setLoadingMining] = useState(false);
	const [isMiner1Active, setIsMiner1Active] = useState(false);
	const [isMiner2Active, setIsMiner2Active] = useState(false);
	const [isMiner3Active, setIsMiner3Active] = useState(false);
	const [isMiner4Active, setIsMiner4Active] = useState(false);

	// Fetch mining status on mount
	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoadingMining(true);
				const response = await axiosPrivate.get(`/singleuser/${auth?.id}`);
				console.log(response.data.foundUser);
				// setMiningProgress(response.data?.activeMiners || 0);
				if (response.data.foundUser.isMiner1Active && minerId === 1) {
					// setIsMining(true);

					setIsMiner1Active(true);
				}

				if (response.data.foundUser.isMiner2Active && minerId === 2) {
					// setIsMining(true);

					setIsMiner2Active(true);
				}

				if (response.data.foundUser.isMiner3Active && minerId === 3) {
					// setIsMining(true);

					setIsMiner3Active(true);
				}

				if (response.data.foundUser.isMiner4Active && minerId === 4) {
					// setIsMining(true);

					setIsMiner4Active(true);
				}

				// setIsMining(response.data?.activeMiners > 0);
			} catch (error) {
				console.log(error);
			} finally {
				setLoadingMining(false);
			}
		};
		fetchData();
	}, []);

	const handleOpen = () => setOpen(true);
	const handleClose = () => {
		setOpen(false);
		setDialogFeedback({ message: "", severity: "" });
	};

	const handleProceed = () => {
		if (Number(auth?.balance) >= price) {
			setConfirmationOpen(true);
		} else {
			setInsufficient(true);
		}
	};

	const handleCancelConfirmation = () => {
		setConfirmationOpen(false);
	};

	// handle
	const handleConfirm = async () => {
		setProcessing(true);
		const payload = {
			userId: auth?.id,
			minerName,
			price,
			hashRate: hash,
			status: "start",
		};

		console.log(payload);
		try {
			const response = await axios.patch("/miner", payload);
			console.log(response);
			if (response.status === 200) {
				setSnackbarMessage("Mining bot started successfully!");
				setSnackbarSeverity("success");
				setSnackbarOpen(true);
				setDialogFeedback({
					message: "Mining bot started successfully!",
					severity: "success",
				});
				handleClose();
				// setIsMining(true);
				if (minerName.includes("1") && minerId === 1) {
					// setIsMining(true);

					setIsMiner1Active(true);
				}

				if (minerName.includes("2") && minerId === 2) {
					// setIsMining(true);

					setIsMiner2Active(true);
				}

				if (minerName.includes("3") && minerId === 3) {
					// setIsMining(true);

					setIsMiner3Active(true);
				}

				if (minerName.includes("4") && minerId === 4) {
					// setIsMining(true);

					setIsMiner4Active(true);
				}
				setMiningProgress(response.data?.activeMiners || 0);
				setMiningProgress((prev) => prev + 1);
			} else {
				setDialogFeedback({
					message: response.data?.message || "Failed to start bot",
					severity: "error",
				});
			}
		} catch (error) {
			setDialogFeedback({
				message: error.response?.data?.message || "Mining failed",
				severity: "error",
			});
		} finally {
			setProcessing(false);
			setConfirmationOpen(false);
		}
	};

	// const handleStartMining = async () => {
	// 	setLoadingMining(true);
	// 	try {
	// 		const response = await axios.post(`/mining/start`, { userId: auth?.id });
	// 		if (response.status === 200) {
	// 			setIsMining(true);
	// 			setMiningProgress((prev) => prev + 1);
	// 			setSnackbarMessage("Mining started!");
	// 			setSnackbarSeverity("success");
	// 			setSnackbarOpen(true);
	// 		}
	// 	} catch (err) {
	// 		console.log(err);
	// 	} finally {
	// 		setLoadingMining(false);
	// 	}
	// };

	const handleStopMining = async () => {
		setLoadingMining(true);
		const payload = {
			userId: auth?.id,
			minerName,
			price,
			hashRate: hash,
			status: "stop",
		};
		try {
			const response = await axios.patch(`/miner`, payload);
			if (response.status === 200) {
				// setIsMining(false);
				if (minerName.includes("1") && minerId === 1) {
					// setIsMining(false);

					setIsMiner1Active(false);
				}

				if (minerName.includes("2") && minerId === 2) {
					// setIsMining(false);

					setIsMiner2Active(false);
				}

				if (minerName.includes("3") && minerId === 3) {
					// setIsMining(false);

					setIsMiner3Active(false);
				}

				if (minerName.includes("4") && minerId === 4) {
					// setIsMining(false);

					setIsMiner4Active(false);
				}
				setMiningProgress(0);
				setSnackbarMessage("Mining stopped");
				setSnackbarSeverity("info");
				setSnackbarOpen(true);
			}
		} catch (err) {
			console.log(err);
		} finally {
			setLoadingMining(false);
		}
	};

	console.log(isMining);
	console.log({ isMiner1Active, isMiner2Active, isMiner3Active });

	return (
		<Box sx={{ maxWidth: 400, mx: "auto", p: 2 }}>
			{/* Main Button with elevated look */}
			<Button
				variant="contained"
				color="primary"
				fullWidth
				size="large"
				onClick={handleOpen}
				endIcon={<KeyboardArrowRightIcon />}
				sx={{ fontSize: "1rem", borderRadius: 2, boxShadow: 3 }}>
				Start Miner
			</Button>

			{/* <MinerProgress /> */}

			{/* Modal with card style */}
			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<Card>
					<CardContent>
						{/* Error or success messages */}
						{dialogFeedback.message && dialogFeedback.severity === "error" && (
							<Typography
								sx={{
									color: "white",
									backgroundColor: "red",
									fontWeight: "bold",
									p: 1.5,
									borderRadius: 2,
									mb: 2,
									textAlign: "center",
								}}>
								{dialogFeedback.message}
							</Typography>
						)}
						{dialogFeedback.message && dialogFeedback.severity !== "error" && (
							<Typography
								sx={{
									color: "green",
									fontWeight: "bold",
									p: 1.5,
									mb: 2,
									borderRadius: 2,
									textAlign: "center",
								}}>
								{dialogFeedback.message}
							</Typography>
						)}

						{/* Info cards with subtle background */}
						<Stack spacing={1}>
							<Typography variant="h6" gutterBottom>
								{minerName}
							</Typography>
							<Typography variant="body1">
								<strong>Price:</strong> ${price}
							</Typography>
							<Typography variant="body1">
								<strong>Hash Rate:</strong> {hash} TH/s
							</Typography>
						</Stack>

						{/* Deduction Note */}
						<Box
							sx={{
								mt: 3,
								p: 2,
								bgcolor: "#fff3cd",
								borderRadius: 2,
								boxShadow: 1,
							}}>
							<Typography variant="body2" color="#856404" align="center">
								The amount of <strong>${price}</strong> will be deducted from
								your balance to start your crypto mining process.
							</Typography>
						</Box>
					</CardContent>

					{/* Action buttons */}
					<DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
						{!confirmationOpen ? (
							<Button variant="outlined" onClick={handleClose}>
								Close
							</Button>
						) : (
							<Button onClick={handleCancelConfirmation}>Cancel</Button>
						)}
						{!confirmationOpen ? (
							<Button
								variant="contained"
								color="primary"
								onClick={handleProceed}>
								Start Mining
							</Button>
						) : (
							<Button
								variant="contained"
								color="primary"
								onClick={handleConfirm}
								disabled={processing}>
								{processing ? "Processing..." : "Confirm"}
							</Button>
						)}
					</DialogActions>
				</Card>
			</Dialog>

			{/* Insufficient funds message */}
			{insufficient && (
				<Typography
					sx={{
						mt: 2,
						p: 1,
						bgcolor: "error.main",
						color: "white",
						borderRadius: 1,
						textAlign: "center",
						maxWidth: 400,
						mx: "auto",
					}}>
					Insufficient balance to start this miner. Please add funds.
				</Typography>
			)}

			{/* Mining Status Panel */}
			<Box
				sx={{
					mt: 4,
					p: 3,
					borderRadius: 3,
					boxShadow: 3,
					backgroundColor: "black",
					maxWidth: 500,
					mx: "auto",
				}}>
				<Typography variant="h6" gutterBottom>
					Mining Status
				</Typography>
				{loadingMining ? (
					<CircularProgress sx={{ display: "block", mx: "auto", my: 2 }} />
				) : (
					<>
						<Typography
							align="center"
							variant="subtitle1"
							gutterBottom
							sx={{
								bgcolor: isMiner1Active
									? "green"
									: isMiner2Active
										? "green"
										: isMiner3Active
											? "green"
											: isMiner4Active
												? "green"
												: "red",
								color: "white",
								p: 1,
								borderRadius: 1,
							}}>
							{/* {isMining || isMiner1Active || isMiner2Active || isMiner3Active
								? `Mining in progress`
								: "Not mining currently"} */}
							{isMiner1Active && minerId === 1
								? `Mining in progress`
								: isMiner2Active && minerId === 2
									? `Mining in progress`
									: isMiner3Active && minerId === 3
										? `Mining in progress`
										: isMiner4Active && minerId === 4
											? `Mining in progress`
											: "Not mining currently"}
						</Typography>
						{/* Progress bar for mining activity */}
						{/* {isMining && <MinerProgress />} */}
						{/* new logic */}
						{isMiner1Active && minerId === 1 && (
							<Box sx={{ my: 2 }}>
								<MinerProgress />
							</Box>
						)}

						{isMiner2Active && minerId === 2 && (
							<Box sx={{ my: 2 }}>
								<MinerProgress />
								<MinerProgress />
							</Box>
						)}
						{isMiner3Active && minerId === 3 && (
							<Box sx={{ my: 2 }}>
								<MinerProgress />
								<MinerProgress />
								<MinerProgress />
							</Box>
						)}
						{isMiner4Active && minerId === 4 && (
							<Box sx={{ my: 2 }}>
								<MinerProgress />
								<MinerProgress />
								<MinerProgress />
								<MinerProgress />
							</Box>
						)}
						{/* {isMiner1Active ? (
							<MinerProgress />
						) : isMiner2Active ? (
							<MinerProgress />
						) : isMiner3Active ? (
							<MinerProgress />
						) : (
							""
						)} */}

						{/* Start/Stop buttons with enhanced style */}

						{isMiner1Active && minerId === 1 ? (
							<Button
								variant="contained"
								color="error"
								fullWidth
								onClick={handleStopMining}
								disabled={loadingMining}
								sx={{ mt: 2, borderRadius: 2 }}>
								{loadingMining ? <CircularProgress size={24} /> : "Stop Mining"}
							</Button>
						) : isMiner2Active && minerId === 2 ? (
							<Button
								variant="contained"
								color="error"
								fullWidth
								onClick={handleStopMining}
								disabled={loadingMining}
								sx={{ mt: 2, borderRadius: 2 }}>
								{loadingMining ? <CircularProgress size={24} /> : "Stop Mining"}
							</Button>
						) : isMiner3Active && minerId === 3 ? (
							<Button
								variant="contained"
								color="error"
								fullWidth
								onClick={handleStopMining}
								disabled={loadingMining}
								sx={{ mt: 2, borderRadius: 2 }}>
								{loadingMining ? <CircularProgress size={24} /> : "Stop Mining"}
							</Button>
						) : isMiner4Active && minerId === 4 ? (
							<Button
								variant="contained"
								color="error"
								fullWidth
								onClick={handleStopMining}
								disabled={loadingMining}
								sx={{ mt: 2, borderRadius: 2 }}>
								{loadingMining ? <CircularProgress size={24} /> : "Stop Mining"}
							</Button>
						) : (
							<Button
								variant="contained"
								color="error"
								fullWidth
								onClick={handleStopMining}
								disabled={loadingMining || true}
								sx={{ mt: 2, borderRadius: 2 }}>
								{loadingMining ? <CircularProgress size={24} /> : "not Mining"}
							</Button>
						)}
					</>
				)}
			</Box>

			{/* Snackbar for feedback */}
			<Snackbar
				open={snackbarOpen}
				autoHideDuration={3000}
				onClose={() => setSnackbarOpen(false)}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
				<Alert
					severity={snackbarSeverity}
					onClose={() => setSnackbarOpen(false)}>
					{snackbarMessage}
				</Alert>
			</Snackbar>
		</Box>
	);
}
